import qs from 'qs';
import { reactive } from 'vue';
import { useRouter } from 'vue-router';
import { cloneDeep, merge, pick } from 'lodash-es';
import { useExchangeAthletesStore, type ExchangeAthletesFilterParams } from '@/stores/exchangeAthletesStore';
import { useSchoolsStore } from '@/stores/schoolsStore';
import { useConferencesStore } from '@/stores/conferencesStore';

export function useExchangeAthletesQueryFilters() {
	const conferencesStore = useConferencesStore();
	const schoolsStore = useSchoolsStore();
	const exchangeAthletesStore = useExchangeAthletesStore();
	const router = useRouter();

	const localFilters = reactive<ExchangeAthletesFilterParams>(cloneDeep(exchangeAthletesStore.athletesFilters));

	const updateFiltersFromQuery = async (query: Partial<ExchangeAthletesFilterParams>) => {
		const allowedkeys = Object.keys(exchangeAthletesStore.DEFAULT_ATHLETES_REQUEST_FILTERS);

		if (query.schools) {
			query.schools = query.schools.filter((school: string) => {
				return schoolsStore.schools.find((s) => s.uuid === school);
			});
		}

		if (query.conferences) {
			query.conferences = query.conferences.filter((conferences: string) => {
				return conferencesStore.conferences.find((c) => c.uuid === conferences);
			});
		}

		exchangeAthletesStore.setAthletesFilters(pick(merge(cloneDeep(exchangeAthletesStore.DEFAULT_ATHLETES_REQUEST_FILTERS), query), allowedkeys) as ExchangeAthletesFilterParams);
	};

	const pushFilterHistory = (forceDeepRouterReactivity: boolean = true) => {
		const query = forceDeepRouterReactivity ? { ...localFilters, key: Date.now() } : localFilters;
		router.push(qs.stringify(query, { addQueryPrefix: true, skipNulls: true }));
	};

	const replaceFilterHistory = () => {
		router.push(qs.stringify(localFilters, { addQueryPrefix: true, skipNulls: true }));
	};

	return {
		localFilters,
		updateFiltersFromQuery,
		pushFilterHistory,
		replaceFilterHistory,
	};
}
